export default function checkIsReadOnly(itineraryInfo) {
	return (
		itineraryInfo &&
		itineraryInfo.itinerary &&
		itineraryInfo.couponVO &&
		itineraryInfo.couponVO.couponPartner === 'CRED' &&
		(itineraryInfo.itinerary.regionCode === 'mle' ||
			itineraryInfo.itinerary.regionCode === 'lka')
	)
}
